export const USER_TYPE = {
    PUBLISHER: 'publisher',
    VIEWER: 'viewer'
};
